import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, switchMap, tap } from 'rxjs/operators';
import { EmailBoxComponent } from '../../../../dim-componentes/email-box/email-box.component';
import { convertB64ToBlob, getErrorMessage, mergeArray } from '../../../../general/utils';
import { DownloadExportacaoService } from '../../../../services/downloadExportacaoController.service';
import { MessageService } from '../../../../services/message.service';
import { UnidadesEmpresaService } from '../../../../services/unidades-empresa.service';
import { ModalCadastroComponent } from '../../../../shared/modal-cadastro/modal-cadastro.component';

@Component({
  selector: 'app-exportar-mdfe',
  templateUrl: './exportar-mdfe.component.html',
  styleUrls: ['./exportar-mdfe.component.css']
})
export class ExportarMDFEComponent extends ModalCadastroComponent implements OnInit {
  constructor(
    private message: MessageService,
    private downloadExportacaoService: DownloadExportacaoService,
    private unidadesEmpresaService: UnidadesEmpresaService
  ) {
    super();
  }

  @ViewChild('modalRelatorio', { static: true }) modalRelatorio;
  @ViewChild('emailBox', { static: true }) emailBox: EmailBoxComponent;
  impressaoForm: FormGroup;
  @Output() closed = new EventEmitter();
  loading = {
    exportacao: false,
  };
  form: FormGroup;

  statusOptions = [
    { id: 'A', name: 'Aprovado', },
    { id: 'C', name: 'Cancelado' },
    { id: 'F', name: 'Encerrado' },
    { id: 'R', name: 'Reprovado' },
    { id: '0', name: 'Sem retorno' },
    { id: 'U', name: 'Rascunho' }
  ];

  ngOnInit() {
    const primeiroDiaDoMesAtual = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

    this.form = new FormGroup({
      emissao1: new FormControl(primeiroDiaDoMesAtual),
      emissao2: new FormControl(null),
      status: new FormControl(['A', 'F', 'C', 'R', '0', 'U']),
      destinatarios: new FormControl(''),
      arquivoUnico: new FormControl(false),
      gerarDamdfe: new FormControl(false),
      gerarXml: new FormControl(true),
      gerarRelatorio: new FormControl(true),
      enviarEmail: new FormControl(true)
    });

    this.unidadesEmpresaService.getUnidadeEmpresa()
      .subscribe(res => {
        if (res.email) {
          this.emailBox.insertEmailString(res.email);
        }

        if (res.contabilidade && res.contabilidade.email) {
          this.emailBox.insertEmailString(res.contabilidade.email);
        }
      });
  }

  show() {
    this.modalRelatorio.show();
  }

  hide() {
    this.modalRelatorio.hide();
  }

  exportar() {
    if (!this.form.get('gerarXml').value && !this.form.get('gerarDamdfe').value && !this.form.get('gerarRelatorio').value) {
      this.message.error('Selecione o tipo de arquivo a ser gerado.', 5000);
      return;
    }

    this.loading.exportacao = true;

    const idToast = this.message.addToast({
      title: 'Exportando...',
      msg: '',
      showClose: false, timeout: 0, theme: 'bootstrap', closeOther: false
    });

    this.downloadExportacaoService.exportarMdfe(this.form.value)
      .pipe(finalize(() => this.loading.exportacao = false))
      .subscribe(response => {
        if (response) {
          saveAs(convertB64ToBlob(response.fileContents, response.contentType), response.fileDownloadName);

          this.message.clear(idToast);
          this.message.addSuccess({
            title: 'Sucesso!',
            msg: 'Documentos exportados com êxito.',
            timeout: 6000
          });
        }
      }, err => {
        this.message.clear(idToast);
        this.message.addError({
          title: 'Erro!',
          msg: getErrorMessage(err),
          showClose: true, timeout: 5000, theme: 'bootstrap', closeOther: true
        });
      });
  }
}
